import { type ApiContainer, type ApiContainerStockEntry } from '@Model';
import {
    EnumFilterExpressionOperation,
    EnumOperation,
    isOk,
    type ListInfo,
    type ListRequest,
    type Result,
} from '@synqo/frontend-component-library';

/** A container offered for a placement, with the site the stock has it standing at right now. */
export type StandingContainer = ApiContainer & { standing_at?: string };

/** Reads one page of the current container stock. */
export type StockReader = (request: ListRequest) => Promise<Result<ListInfo<ApiContainerStockEntry>>>;

/** The page's containers with the site each stands at, read from the stock in one request; unchanged if it fails. */
// @ai-generated 2026-10-21T12:37:24+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5
export async function withStandingSites(
    page: ListInfo<ApiContainer>,
    readStock: StockReader,
): Promise<ListInfo<StandingContainer>> {
    if (page.items.length === 0) {
        return page;
    }

    const stock = await readStock(standingTimesOf(page.items.map((container) => container.id)));
    if (!isOk(stock)) {
        return page;
    }

    const siteOf = new Map(stock.data.items.map((entry) => [entry.container.foreign_key, entry.site.display_string]));

    return { ...page, items: page.items.map((container) => ({ ...container, standing_at: siteOf.get(container.id) })) };
}

// @ai-generated 2026-10-21T12:37:24+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5
function standingTimesOf(containerIds: string[]): ListRequest {
    return {
        page_no: 0,
        page_size: containerIds.length,
        full_text_search: '',
        sort_columns: [],
        filter_columns: {
            operation: EnumFilterExpressionOperation.Or,
            filters: containerIds.map((id) => ({
                field: 'container.foreign_key',
                value: id,
                operator: EnumOperation.Equal,
            })),
        },
    };
}
